<div class="row full-height">
  <div class="col-md-12 col-sm-12 d-flex">
    <form #createEditProjectForm="ngForm" class="add-to-campaign-form d-flex flex-auto" novalidate>
      <div class="d-flex flex-column flex-auto edit-project-form">
        <div class="bottombar-buttons">
          <button *ngIf="project.id > 0" class="button green pull-right" [attr.disabled]="!canCreateOrUpdateProject ? 'disabled' : null" type="button" (click)="createOrEditProject()">
            {{'measure.update_project_button' | translate}}
          </button>
          <button *ngIf="project.id === 0" class="button green pull-right" [attr.disabled]="!canCreateOrUpdateProject ? 'disabled' : null" type="button" (click)="createOrEditProject()">
            {{'measure.save_project_button' | translate}}
          </button>
          <button class="button red pull-right" type="button" (click)="showWarningBeforeCancelingProject()">{{'common.btn.back' | translate}}</button>
        </div>
        <div class="edit-project-form-content bottombar-content form-content flex-auto">
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12">
              <div class="material-field xl-field">
                <achoo-material-input label="{{'project.project_name' | translate}}"
                                      placeholder="{{'project.project_name_placeholder' | translate}}"
                                      name="project_name"
                                      [(model)]="project.name">
                </achoo-material-input>
              </div>
              <div class="material-field">
                <achoo-keywork-input-field #mentionInput label="{{'campaigns.mentions' | translate}}"
                                           name="project_keywords"
                                           [activePage]="activePage"
                                           [actionSource]="actionSource"
                                           [mentions]="project.keywords"
                                           [checkMentionExisting]="false"
                                           [enableCountry]="showCountryList"
                                           [countries]="project.countries"
                                           [isEditProjectFragment]="true"
                                           (beforeProgressingMention)="beforeAddingNewMontion($event)"
                                           (afterProgressingMention)="afterAddingNewMentionForProject($event)">
                </achoo-keywork-input-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<achoo-popup #NotificationAfterProjectUpdateSuccess
             [isNotification]="true"
             (cancelCallback)="closeNotification($event)"
             modelTitle="{{'notification.success' | translate}}">
  <span>{{getNotificationContent()}}</span>
</achoo-popup>
<achoo-popup #WarningCancelEditProject
             [isAlertPopup]="true"
             acceptBtnLabel="{{'common.btn.ok' | translate}}"
             cancelBtnLabel="{{'common.btn.cancel' | translate}}"
             (cancelCallback)="closeWarningPopup()"
             (acceptCallback)="closeEditProject()">
  <span>{{'project.cancel_edit_project' | translate}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/measure/edit-project/edit-project.component.html